<template>
 <div class="px-5 pt-1 h-100" id="violation-info">
   <div class="container-fluid h-100" id="form">
     <div class="row" v-if="!loading">
       <div class="col-md-12">
         <v-clappr el="violation" :source="item.LINK_VIDEO" :options="options" />
       </div>
       <div class="col-md-12 mt-3">
         <div>{{ item.DATE }}</div>
         <template v-if="item.STATUS_INFRINGEMENT">
           <br>
           <div :class="{ 'badge fs-2x mb-1' : true, 'badge-danger' : item.STATUS_INFRINGEMENT === 'sent', 'badge-warning' : item.STATUS_INFRINGEMENT === 'returned', 'badge-primary' : item.STATUS_INFRINGEMENT !== 'sent' && item.STATUS_INFRINGEMENT !== 'returned'}">
             <template v-if="Object.prototype.hasOwnProperty.call(statuses, item.STATUS_INFRINGEMENT)">
               {{ statuses[item.STATUS_INFRINGEMENT] }}
             </template>
             <template v-else>
               Не указан
             </template>
           </div>
         </template>
         <div class="h4"><template v-if="item.INFRINGEMENT_TYPE_FK">{{ item.INFRINGEMENT_TYPE_FK['display'] }}</template><template v-else>не указано</template></div>
         <div class="mt-1">
           <template v-if="item.SCHOOL_FK"><b class="text-muted">ППЭ:</b> {{ item.SCHOOL_FK.display }}<br></template>
           <b class="text-muted">Аудитория:</b> <template v-if="item.CLASSROOM_FK">{{ item.CLASSROOM_FK.display }}</template><template v-else>не указана</template><br>
           <b class="text-muted">Место:</b> <span v-if="item.POSITION">{{ item.POSITION }}</span><span v-else>не указано</span></div>
           <div>
             <b class="text-muted">Комментарий: </b>
             <template v-if="item.COMMENT">
               <span v-html="item.COMMENT" class="mt-1"></span>
             </template>
             <template v-else>
               <span class="mt-1">не указано</span>
             </template>
           </div>

           <small class="mt-1 text-muted" v-if="item.USER_FK"><b>Добавлено:</b> {{ item.USER_FK.display }}</small>
           <div v-if="history.length === 0 && item.STATUS_COMMENT">
             <hr>
             <h4>Результат отработки нарушения</h4>
             <p v-html="item.STATUS_COMMENT"></p>
           </div>
       </div>

       <b-tabs content-class="mt-3" align="right" class="col-md-12  ui-tabs">
         <b-tab :title="(canProcess ? 'Отработка' : 'Проверка') +  ' нарушения' " :active="canProcess || canConfirm" v-if="canProcess || canConfirm">
           <div class="mt-3" v-if="canProcess">
             <h4>Отработка нарушения</h4>
             <form class="form p-3" @submit.prevent="process()">
               <div class="form-group row">
                 <label for="comment" class="text-white">Комментарий</label>
                 <textarea class="form-control bg-dark text-light" id="comment" v-model="comment" rows="5"></textarea>
               </div>
               <div class="form-group row text-right">
                 <button type="submit" class="btn btn-primary">Сохранить</button>
               </div>
             </form>
           </div>
           <div class="mt-3" v-if="canConfirmViolation && item.STATUS_INFRINGEMENT === 'review'">
             <h4>Проверка нарушения</h4>
             <form class="form py-4" @submit.prevent="confirm()">
               <div class="form-group row mx-0">
                 <div>
                   <label class="text-white mr-3 mt-1">Результат проверки</label>
                 </div>
                 <div>
                   <template v-for="(name, key) in statuses">
                     <div v-if="key !== 'sent' && key !== 'review'" class="form-check form-check-inline" :key="key">
                       <input class="form-check-input d-none" type="radio" :id="key+'radio'" :value="key" v-model="status">
                       <label :class="{ 'form-check-label btn btn-outline-primary' :true,  'active' : status === key}" :for="key+'radio'">{{ name }}</label>
                     </div>
                   </template>
                 </div>
               </div>
               <div class="form-group">
                 <label for="comment" class="text-white">Комментарий</label>
                 <textarea class="form-control bg-dark text-light" id="confirmcomment" v-model="comment" rows="5"></textarea>
               </div>
               <div class="form-group">
                 <button type="submit" class="btn btn-primary">Сохранить</button>
               </div>
             </form>
           </div>
         </b-tab>
         <b-tab title="История изменений" :active="!canProcess && !canConfirm">
           <ul class="timeline mt-3"  v-if="history.length > 0">
             <li v-for="(entry, index) in history" :key="index">
               <div class="timestamp"><b class="text-muted">Дата:</b> {{ entry.STATUS_DATE }}</div>
               <div><b class="text-muted">Статус:</b> {{ statuses[entry.STATUS] }}</div>
               <div v-if="entry.STATUS_COMMENT "><b class="text-muted">Комментарий:</b> {{ entry.STATUS_COMMENT }}</div>
               <div v-if="entry.USER_FK && Object.prototype.hasOwnProperty.call(entry.USER_FK,'display') "><b class="text-muted">Добавлено:</b> {{ entry.USER_FK.display }}</div>
                <hr>
             </li>
           </ul>
           <template v-else>
                <p class="text-center text-muted"> Здесь пока ничего нет</p>
           </template>
         </b-tab>
       </b-tabs>
     </div>
     <div class="h-100 d-flex justify-content-center align-items-center text-muted" v-else>
       <font-awesome-icon :icon="['fas', 'spinner']" pulse class="fa-3x text-muted"></font-awesome-icon>
     </div>
   </div>
 </div>
</template>

<script>
  import { apiQuery } from "../api";
  import VClappr from 'v-clappr'
  import { Browser } from 'clappr'
  import Vuex from 'vuex'
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    name: "Contravention",
    components: { VClappr },
    data() {
      return {
        item: {},
        loading: true,
        comment: '',
        action: '',
        status: 'processed',
        history: [],
        actions: [],
        errors: [],
        options: {
          width: 'auto',
          height: this.height,
          poster: '',
          mute: true,
          autoplay: true,
          loop: false,
          disable_context_menu: false,
          disable_keyboard_shortcuts: false,
          mediacontrol: {},
          ga: {
            account: '',
            tracker_name: '',
          },
          watermark: {
            image: '',
            url: '',
            position: 'top-right',
          },
          plugins: [],
          chromeless: false,
          allow_user_interaction: false,
          i18n: {
            en: {
              live: 'прямая трансляция',
              back_to_live: 'вернуться к трансляции',
              disabled: 'выключено',
              playback_not_supported: 'Похоже, ваш браузер не поддерживает трансляцию',
              default_error_title: 'Не удалось воспроизвести видео',
              default_error_message: 'Проблема при загрузке видео. Повтор....',
            },
          },
          mime_type: '',
          actual_live_time: '',
          preload: '',
          playback: {
            preload: 'metadata',
            controls: false,
            playInline: true, // allows inline playback when running on iOS UIWebview
            crossOrigin: '',
            recycleVideo: Browser.isMobile, // Recycle <video> element only for mobile. (default is true)
            triggerFatalErrorOnResourceDenied: true, // Triggers playback fatal error if resource is denied. (default is false)
            externalTracks: [],
            hlsUseNextLevel: false,
            hlsjsConfig: {},
          },
          cc: {
            title: '',
            ariaLabel: '',
            labelCallback: () => {},
          },
        },
      }
    },
    computed: {
      ...Vuex.mapGetters([
        'canProcessViolation',
        'canConfirmViolation'
      ]),
      statuses() {
        return window.x2.violation
      },
      canProcess() {
        return this.canProcessViolation && (this.item.STATUS_INFRINGEMENT === 'sent' || this.item.STATUS_INFRINGEMENT === 'returned')
      },
      canConfirm() {
        return this.canConfirmViolation && this.item.STATUS_INFRINGEMENT === 'review'
      }
    },
    mounted() {
      this.loadItem();
      this.loadHistory()
    },
    methods: {
      loadItem() {
        apiQuery('private', 'data-get-record', {
          table: window.x2.tables.violations,
          recordId: this.$route.params.id
        }, false).then(response => {
          this.item = response
          if (process.env.NODE_ENV === 'development')
            this.item.LINK_VIDEO = this.item.LINK_VIDEO.replace('https://smotrigia.pskovedu.ru', '')
          if (!this.item.LINK_VIDEO.startsWith(window.location.origin))
            this.item.LINK_VIDEO = window.location.origin + (this.item.LINK_VIDEO.startsWith('/') ? '' : '/') + this.item.LINK_VIDEO
          // if (Object.prototype.hasOwnProperty.call(this.item, 'STATUS_COMMENT') && Object.prototype.hasOwnProperty.call(this.item, 'STATUS_INFRINGEMENT') && this.item.STATUS_INFRINGEMENT === 'review')
          //   this.comment = this.item['STATUS_COMMENT']
          this.loading = false
          setTimeout(() => {
            new PerfectScrollbar('#violation-info', {wheelPropagation: false})
          }, 100);
        })
      },
      loadHistory() {
        this.history = []
        apiQuery('private', 'data-get-records', {
          table: window.x2.tables.history,
          context: {
            state: {
              [window.x2.tables.violations]: this.$route.params.id
            }
          },
          sort: [{
              field: 'STATUS_DATE',
              dir: 'DESC'
          }]
        }, false).then(res => {
          this.history = res.rows
        })
      },
      process() {
        this.$set(this.item, 'STATUS_INFRINGEMENT', 'review')
        this.$set(this.item, 'STATUS_COMMENT', this.comment)
        this.save()
      },
      confirm() {
        if (this.status !== '' && this.status !== 'review')
          this.$set(this.item, 'STATUS_INFRINGEMENT', this.status)
        this.$set(this.item, 'STATUS_COMMENT', this.comment)
        this.save()
      },
      save() {
        this.loading = true
        return apiQuery('private', 'data-update-record', {
          table: window.x2.tables.violations,
          id: this.item['SYS_GUID'],
          record: {
            table: window.x2.tables.violations,
            data: this.item
          }
        }, false).then(response => {
          this.$bvToast.toast('Данные сохранены', {
            title: 'Внимание',
            variant: 'success',
            solid: true
          })
          this.item = {}
          this.item = response
          this.loadHistory()
          this.comment = ''
          this.loading = false
          setTimeout(() => { this.$emit('processed'); }, 500)
        }).catch(err => {
          this.errors = err
          this.$bvToast.toast(err.toString(), {
            title: 'Произошла ошибка',
            variant: 'danger',
            solid: true
          })
        })
      }
    }
  }
</script>

